/**
 * @packageDocumentation
 * @module api.functional.admin.invitations.preview
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

import type { InvitationPreviewDto } from "../../../../structures/InvitationPreviewDto";

/**
 * @controller InvitationController.getInvitationPreview
 * @path GET /admin/invitations/preview/:token
 * @accessor api.functional.admin.invitations.preview.getInvitationPreview
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function getInvitationPreview(
  connection: IConnection,
  token: string,
): Promise<getInvitationPreview.Output> {
  return PlainFetcher.fetch(connection, {
    ...getInvitationPreview.METADATA,
    template: getInvitationPreview.METADATA.path,
    path: getInvitationPreview.path(token),
  });
}
export namespace getInvitationPreview {
  export type Output = InvitationPreviewDto;

  export const METADATA = {
    method: "GET",
    path: "/admin/invitations/preview/:token",
    request: null,
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = (token: string) =>
    `/admin/invitations/preview/${encodeURIComponent(token?.toString() ?? "null")}`;
}
